export type CouponKind = 'DISCOUNT_PERCENT' | 'FREE_DAYS' | string;

export type AppliedCoupon = {
  code: string;
  type: CouponKind;
  discountPercent?: number;
  freeDays?: number;
  message?: string;
  raw?: unknown;
};

export type PaymentFormData = {
  contactPhone: string;
  holderName: string;
  holderDocument: string;
  cardNumber: string;
  cardExpiry: string;
  cardCvv: string;
  billingZip: string;
  billingStreet: string;
  billingNumber: string;
  billingComplement: string;
  billingDistrict: string;
  billingCity: string;
  billingState: string;
};

export const createEmptyPaymentFormData = (): PaymentFormData => ({
  contactPhone: '',
  holderName: '',
  holderDocument: '',
  cardNumber: '',
  cardExpiry: '',
  cardCvv: '',
  billingZip: '',
  billingStreet: '',
  billingNumber: '',
  billingComplement: '',
  billingDistrict: '',
  billingCity: '',
  billingState: ''
});

export type BillingOfferCode = 'MONTHLY_RECURRING' | 'ANNUAL_RECURRING' | 'ANNUAL_UPFRONT';

export type BillingOffer = {
  code: BillingOfferCode;
  label: string;
  description: string;
  planName: string;
  amountCents: number;
  originalAmountCents: number;
  discountPercent: number;
  billingCycle: 'MONTHLY' | 'YEARLY';
  paymentMode: 'RECURRING' | 'ONE_TIME';
  recurring: boolean;
};

export type PaymentFieldErrors = Record<string, string>;

export type PaymentNotice = {
  message?: string;
  requiresPayment?: boolean;
  paymentRequired?: boolean;
  status?: string;
  reason?: string;
  trialEndsAt?: string | null;
  accessEndsAt?: string | null;
  dueAt?: string | null;
  billingOfferCode?: BillingOfferCode | null;
  billingCycle?: 'MONTHLY' | 'YEARLY' | string | null;
  paymentMode?: 'RECURRING' | 'ONE_TIME' | string | null;
  recurring?: boolean;
  amountCents?: number | null;
  nextChargeAt?: string | null;
  subscriptionStatus?: string | null;
  couponCode?: string | null;
  couponType?: CouponKind | null;
  couponFreeDays?: number | null;
  [key: string]: unknown;
};
